// @flow
import React, { Fragment } from 'react';
import { get as _get } from 'lodash';
import Dropdown from '@localytics/loc-components/lib/Dropdown';
import EventAttributeForm from './EventAttributesForm';

import type { OperatorOptionsType } from '../../constants/ApiTypes';
import type {
  EventMapping,
  AttributeGroup
} from '../../constants/RailsApiTypes';

type EventSelectionFormProps = {
  eventMappings: Array<EventMapping>,
  onEventUpdate: Function,
  onAttributeUpdate: Function,
  onOperatorUpdate: Function,
  onAttributeValuesUpdate: Function,
  disabled?: boolean,

  selectedEvent: ?EventMapping,
  selectedAttribute: ?AttributeGroup,
  selectedOperator: ?OperatorOptionsType,
  selectedAttributeValues: Array<string>
};

function eventOptionsFromEventMappings(eventMappings) {
  return eventMappings
    .map(e => ({
      label: _get(e, 'name'),
      value: _get(e, 'id'),
      ...e
    }))
    .sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));
}

export default function EventSelectionForm(props: EventSelectionFormProps) {
  const {
    selectedEvent,
    eventMappings,
    onAttributeUpdate,
    onEventUpdate,
    onOperatorUpdate,
    onAttributeValuesUpdate,
    selectedAttribute,
    selectedOperator,
    selectedAttributeValues,
    disabled
  } = props;
  const eventOptions = eventOptionsFromEventMappings(eventMappings);

  const event = {
    ...selectedEvent,
    label: _get(selectedEvent, 'name')
  };

  return (
    <Fragment>
      <div className="EventNodeModal__Form">
        <div className="EventNodeModal__FormRow">
          <div className="EventNodeModal__FormLeft">
            <span
              style={{
                color: '#3F404A',
                fontWeight: '600',
                display: 'inline-block'
              }}
            >
              When users perform event
            </span>{' '}
          </div>

          <div className="EventNodeModal__FormRight">
            <div className="EventNodeModal__InputsContainer">
              <Dropdown
                name="event"
                className="EventNodeModal__DropdownWide"
                selectedValue={event}
                options={eventOptions}
                onSelect={onEventUpdate}
                clearable={false}
                disabled={disabled}
                placeholder="Choose an event"
              />
            </div>
          </div>
        </div>
        {selectedEvent && (
          <EventAttributeForm
            selectedEvent={selectedEvent}
            selectedAttribute={selectedAttribute}
            selectedOperator={selectedOperator}
            selectedValues={selectedAttributeValues}
            onAttributeUpdate={onAttributeUpdate}
            onOperatorUpdate={onOperatorUpdate}
            onAttributeValuesUpdate={onAttributeValuesUpdate}
            disabled={disabled}
          />
        )}
      </div>
    </Fragment>
  );
}

EventSelectionForm.defaultProps = {
  disabled: false
};



// WEBPACK FOOTER //
// ./src/components/EventAttributes/EventSelectionForm.jsx